<template>
  <v-dialog v-model="dialog" @click:outside="handleOutsideClick" transition="dialog-bottom-transition">
    <v-card class="mx-auto full-screen-modal" min-width="100%">

      <v-form :lazy-validation="true" v-model="form" ref="form">
        <v-btn icon @click.prevent="closeDialog" class="close-btn">
    <v-icon>mdi-close</v-icon>
  </v-btn>
        <v-container>
          
          <!-- <v-text-field v-model="up_iid" color="primary" label="アイテムID（デバッグ用）" variant="underlined"></v-text-field> -->
          <v-text-field v-model="up_name" color="primary" :label="$t('item_dialog.name')" :rules="[required]"
            variant="underlined"></v-text-field>
            
          <v-text-field v-model="up_ex_date" type="date" color="primary" :label="$t('item_dialog.ex_date')"
            :rules="[required]" variant="underlined"></v-text-field>

          <v-select v-model="up_cat" :items="enhancedCategoryOptions" item-title="name" item-value="cat_id"
            :label="$t('item_dialog.cat')" variant="underlined"></v-select>

          <div style="display: flex; gap: 10px; align-items: center; margin: 10px 0;">
            <v-btn @click="triggerCameraInput"><v-icon>mdi-camera</v-icon></v-btn>
          </div>

          <input type="file" accept="image/*;capture=camera" @change="handleFileChange" :label="$t('item_dialog.camera')"
            ref="fileInput" style="display: none;">

          <div v-if="imagePreview" class="image-preview position-relative">
            <div class="image-preview-container">
              <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
              <v-btn class="position-absolute top-0 right-0" icon @click="clearImage">
                <v-icon color="red">mdi-trash-can</v-icon>
              </v-btn>
            </div>
          </div>

          <v-text-field v-model="up_count" type="number" min="1" color="primary" :label="$t('item_dialog.count')"
            variant="underlined"></v-text-field>
          <v-text-field v-model="up_note" color="primary" :label="$t('item_dialog.note')"
            variant="underlined"></v-text-field>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions style="justify-content: flex-end;">
          <v-btn class="ml-12" v-if="input_type === 'update'" color="error" :disabled="!form" :loading="delete_btn_loading"
            size="large" type="button" variant="elevated" @click="delete_item">
            <v-icon>mdi-trash-can-outline</v-icon>
            {{ $t('item_dialog.delete') }}
          </v-btn>

          <v-btn class="ml-12" v-if="input_type === 'update'" color="success" :disabled="!form" :loading="update_btn_loading"
            size="large" type="button" variant="elevated" @click="update_item">
            <v-icon left>mdi-check</v-icon>
            {{ $t('item_dialog.update') }}
          </v-btn>

          <v-btn class="ml-12" v-if="input_type === 'regist'" color="success" :disabled="!form" :loading="regist_btn_loading"
            size="large" type="button" variant="elevated" @click="regist_item">
            <v-icon left>mdi-check</v-icon>
            {{ $t('item_dialog.register') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script src="./ItemDialog.js"></script>

<style src="./ItemDialog.css" scoped></style>
